import type { PieceModel } from './types';

const clean = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(clean);
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value)) {
      if (val === null) continue; // absent means the default; a null would be a third meaning
      out[key] = clean(val);
    }
    return out;
  }
  return value;
};

/**
 * Prepares a model to persist without changing any value: drops nulls and returns a fresh copy
 * that shares nothing with the live Fabric objects. Sizes and positions stay exactly as captured.
 */
export const normalizeModel = (model: PieceModel): PieceModel => clean(model) as PieceModel;
